module.exports = "<div class=\"theme-winter no-bg\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n"